<template>
  <div :class="{ 'c-dark-theme': $store.state.darkMode, animated: false, fadeIn: true }">

    <!-- 최근경보 / 경보현황 / 경보지연 설정 : 상단 3등분 ----------------->

    <CCard>
      <CCardHeader class="py-2 d-flex justify-content-between align-items-center">
        <span><BIconColumnsGap class="mr-1"/> <b>경보판</b></span>
        <BButton size="sm" variant="outline-info" @click="openAlarmBoardPopup">
          <BIconArrowsFullscreen/> <b>경보판 팝업</b>
        </BButton>
      </CCardHeader>
      <CCardBody>
        <AlarmBoard @select-code="onSelectEventCode"/>
      </CCardBody>
    </CCard>


    <!-- 이벤트 리스트 ------------------------------------------------------>

    <CCard class="mt-2">
      <CCardHeader>
        <BRow>
          <BCol sm="2">
            <BIconBellFill/> 경보조회
          </BCol>
          <BCol class="small">
            <BInputGroup size="sm">
              <BInputGroupAppend>
                <BFormSelect size="sm" v-model="tid" :options="tankOpts" class="theme-select"/>
                <BFormSelect size="sm" v-model="evtCode" :options="eventOpts" class="theme-select"/>
              </BInputGroupAppend>
            </BInputGroup>
          </BCol>
          <BCol sm="6">
            <BInputGroup size="sm">
              <BFormSelect size="sm"
                           v-model="fromDays"
                           @input="selectDayOpts"
                           :options="dayFromOpts"
               class="theme-select"/>
              <BFormInput size=sm type="date" v-model="fromDts"></BFormInput>
              <BInputGroupAppend size="sm">
              <BInputGroupText  class="small">~</BInputGroupText>
              </BInputGroupAppend>
              <BFormInput size=sm type="date" v-model="toDts"></BFormInput>
              <BInputGroupAppend size="sm">
                <BButton variant="info" size="sm" @click="onSearchBtnClick"><BIconSearch/> 검 색</BButton>
              </BInputGroupAppend>
            </BInputGroup>
          </BCol>
        </BRow>
      </CCardHeader>

      <CCardBody>

        <BTable
          ref="eventTable"
          sticky-header
          sticky-column
          small
          select-mode="single"
          selected-variant="primary"
          thead-class="text-center"
          head-variant="light"
          class="text-nowrap small"
          :fields="eventFields"
          :items="rows"
          @row-selected="rowSelected"
        >
          <template #cell(tnm)="{item}">
             {{ tankMap[item.tid]?.name }}
          </template>

          <template #cell(tankCode)="{item}">
            <BBadge class="font-sm">{{ tankMap[item.tid]?.tankCode }}</BBadge>
          </template>

          <template #cell(name)="{item}">
            <BBadge class="font-sm" :variant="eventColor[item.code]">{{ item.name }}</BBadge>
          </template>

          <template #cell(text)="{item}">
            {{ item.text }}
          </template>
        </BTable>

        <BRow>
          <BCol>
            <BButton variant="warning"
                     size="sm"
                     :disabled="totalRows===0 || !query"
                     v-b-modal.download-modal>
              <BIconDownload/> <b>로그 다운로드</b>
            </BButton>
          </BCol>

          <BCol>
            <BBadge variant="info" class="font-lg ml-2 mt-1 float-right">{{totalRows}} 건</BBadge>
            <BPagination
              align="right"
              size="sm"
              :total-rows="totalRows"
              :per-page="perPage"
              @change="getList"
            ></BPagination>
          </BCol>
        </BRow>

      </CCardBody>
    </CCard>
    <CRow>
      <CCol>
        <CCardGroup columns class="card-columns cols-3">
          <CCard v-for="item in dataMap" :key="item.tid">
            <CCardHeader>
              <BBadge variant="info" class="font-sm">{{ tankMap[item.tid]?.name }}</BBadge> <BBadge>{{tankMap[item.tid]?.tankCode}}</BBadge>
            </CCardHeader>
            <CCardBody>
              <CChartPie
                style="min-height: 300px"
                :datasets="[item.datasets]"
                :labels="labelsMap[item.tid]"
              />
            </CCardBody>
          </CCard>
        </CCardGroup>
      </CCol>
    </CRow>

    <!-- 경보판 팝업 : 세 카드를 한 화면에 크게 보여준다 -->
    <BModal ref="download-modal" id="download-modal" hide-footer
            header-bg-variant="warning"
            title="다운로드 사유 입력">
      <BFormInput class="mb-1" v-model="downloadReason" placeholder="5글자 이상 작성해주세요"/>


        <BButton class="btn btn-block btn-danger"
                 @click.prevent="downloadEventLog"
                 :disabled="downloadReason.length < 5">
          <BIconDownload/>
          다운로드
        </BButton>
    </BModal>


  </div>
</template>



<script>

//-------------------------------------------------------------------------------------------------
import '@/common/HelperMixin';
import {
  accessLogging,
  apiCall, toastSync,
} from '@/common/utils';
import moment from "moment";
import qs from 'querystring';
import { CChartPie } from '@coreui/vue-chartjs'
import AlarmBoard from '@/views/components/alarm/AlarmBoard';


// $blue: #007bff !default;
// $indigo: #6610f2 !default;
// $purple: #6f42c1 !default;
// $pink: #e83e8c !default;
// $red: #dc3545 !default;
// $orange: #fd7e14 !default;
// $yellow: #ffc107 !default;
// $green: #28a745 !default;
// $teal: #20c997 !default;
// $cyan: #17a2b8 !default;


const _eventBgColor = {
    '1':'#ffc107', // 넘침
    '2':'#007bff', // 부족
    '3':'#ff0000',  // 화재
    '4':'#1730b8',    // 수분
    '5':'#10dF20',  // 누유
    '6':'#ff3545',  // 넘침2
    '7':'#201020',  // 부족2
    '8':'#f8f9fa',   // 센서점검 (서버가 내보내지 않음)
    '9':'#6610f2'  // 설정점검 (점검류 경보는 모두 9)
}


//----------------------------------------------------------------------------------------------------
export default {
  name: "Events",
  components: {
    CChartPie,
    AlarmBoard,
  },
  props: {
    from: { type: Number, default: 3 },
    code: { type: String, default: '' },
    tankId: { type: String, default: '' },
  },
  data () {
    return {
      tid: '',
      evtCode: '',

      pickerShow: false,
      eventCodeMap: this.$store.state.codeMaps['EVENT'],
      tankOpts : this.$store.state.tanks['opts'],
      eventOpts : this.$store.state.codeOpts['EVENT'],
      isCreateMode: false,
      rows: [],

      eventFields: [
        { key: 'createdAt', sortable: false, tdClass: 'font-weight-bold', tdStyle: 'min-width: 300px', label:'경보일시',formatter: v=>this.toLocalTimeSec(v) },
        { key: 'dt', sortable: false, tdClass: 'font-weight-bold', tdStyle: 'min-width: 300px', label:'발생일시',formatter: v=>this.toLocalTimeSec(v) },
        { key: 'tnm'      , sortable: false, tdClass: 'text-center font-weight-bold', label:'탱크명'},
        { key: 'tankCode' , sortable: false, tdClass: 'text-center font-weight-bold', label:'탱크코드' },
        // { key: 'tid'      , sortable: true, tdClass: 'text-center font-weight-bold', label:'탱크번호'},
        { key: 'code'     , sortable: false, label:'경보코드', tdClass: 'text-center font-weight-bold'},
        { key: 'name'     , sortable: false, label:'경보명'},
        { key: 'text'  ,  sortable: false, label:'경보내용' },
      ],
      page: 1,
      perPage: 10,
      totalRows: 0,
      formShow: false,
      isSubmitting: false,
      isShowGraph: false,
      row: null,
      eventColor: {
        '1':'warning', // 넘침
        '2':'primary', // 부족
        '3':'danger',  // 화재
        '4':'info',    // 수분
        '5':'success',  // 누유
        '6':'danger',  // 넘침2
        '7':'dark',    // 부족2
        '8':'light',   // 센서점검 (서버가 내보내지 않음)
        '9':'secondary'  // 설정점검 (점검류 경보는 모두 9)
      },
      fromDays: 3,
      fromDts: moment().subtract(this.fromDays, 'days').format('YYYY-MM-DD'),
      toDts: moment().format('YYYY-MM-DD'),
      dayFromOpts: [
        {value:3, text:'최근 3일'},
        {value:7, text:'최근 7일'},
        {value:14, text:'최근 2주'},
        {value:28, text:'최근 4주'},
        {value:90, text:'최근 3개월'},
      ],
      labelsMap: {},
      dataMap: {},
      downloadReason: '',
      excelFields: {
        '경보일시': {field: 'createdAt', callback: (v)=>{ return moment(v).format('YYYY-MM-DD HH:mm:ss')}},
        '발생일시': {field: 'dt', callback: (v)=>{ return moment(v).format('YYYY-MM-DD HH:mm:ss')}},
        '탱크명': {field: 'tid', callback: (v)=>{ return this.tankMap[v]?.name }},
        '탱크코드': {field: 'tid', callback: (v)=>{ return this.tankMap[v]?.tankCode }},
        '경보코드': 'code',
        '경보명': {field: 'code', callback: (v)=>{ return this.eventCodeMap[v] }} ,
        '경보내용': 'text'
      },
      fileName: '',
      query: '',

    }

  },
  async created(){
    try{
      this.fromDays = this.from? this.from: this.fromDays;
      this.evtCode = this.code? this.code: this.evtCode;
      this.tid = this.tankId? this.tankId:this.tid;

      this.fromDts =  moment().subtract(this.fromDays, 'days').format('YYYY-MM-DD');
      this.toDts = moment().format('YYYY-MM-DD');
      await this.getList();
    }catch(err){
      console.log(err);
    }
  },

  computed: {
    // 탱크 맵은 스토어를 직접 본다. data() 에서 복사하면 새로고침으로 이 화면에 바로 들어올 때
    // 기초 데이터 적재 전 값(undefined)이 굳어져 표 렌더링이 깨진다.
    tankMap(){
      return this.$store.state.tanks['map'] || {};
    },
    userRows(){
      return this.rows.length;
    },
  },

  mounted() {
    console.log("--- Events mounted---------------------");
    // below is not work!
  },

  methods: {
    async selectDayOpts(){
      this.toDts = moment().format('YYYY-MM-DD');
      this.fromDts = moment().subtract(this.fromDays,'days').format('YYYY-MM-DD');
      await this.getList();
    },


    async downloadEventLog(){
      try{

        this.isDownloading = true;
        const r = await apiCall('postfile', `/api/event/log-download?${this.query}`, {});
        const fileName = `event-log_${this.fromDts}_${this.toDts}.xlsx`;
        await this.getDownload(fileName, r);
        this.$refs['download-modal'].hide();
      }catch(err){
        console.error(err);
        this.toastError(err);
      }finally{
        this.isDownloading = false;
      }

    },

    /** 경보판을 별도 팝업 창으로 띄운다 (모니터 팝업과 같은 방식) */
    openAlarmBoardPopup(){
      const route = this.$router.resolve({ path: '/alarm-board' });
      const features = 'left=0,top=0,width=1500,height=900,status=no,titlebar=no,location=no,menubar=no,toolbar=no,scrollbars=yes';
      const newWin = window.open(route.href, 'alarm_board', features);
      if(!newWin){
        this.toastWarn('팝업이 차단되었습니다. 브라우저 팝업 허용 후 다시 시도하세요.');
        return;
      }
      // 팝업 창은 별도 앱 인스턴스라 인증정보를 넘겨준다
      newWin.storedUser = localStorage.user;
    },

    /** 경보판에서 경보를 고르면 조회 조건에 반영해 재조회 */
    async onSelectEventCode(code){
      this.evtCode = code;
      await this.getList();
    },

    onSearchBtnClick(){
      this.isShowGraph = true;
      this.getList();
    },

    async getList(p=1){
      this.page = p;
      let query= '';
      let paramMap = {};
      // if(!this.tid &&  this.tankOpts.length > 1 ){
      //   this.tid = this.tankOpts[1].value;
      //   this.tid = this.tankOpts[1].value;
      // }

      try{

        // console.log( "getList() --- query-string ----> ");
        if(this.tid) paramMap['tid'] = this.tid;
        if(this.evtCode) paramMap['code'] = this.evtCode;
        if(this.fromDts) paramMap['fromDts'] = this.fromDts;
        if(this.toDts) paramMap['toDts'] = this.toDts;
        paramMap['page'] = this.page;
        paramMap['perPage'] = this.perPage;
        paramMap['aggr'] = this.isShowGraph?'Y':'N';

        query = qs.stringify(paramMap);
        console.log('getList---query:', query);
        this.query = query;
        // this.rows = [];
        const r = await apiCall('get', `/api/event?${query}`);

        if(r.code===200){
          if(this.page===1) await this.toastInfo(`경보 정보 ${r.result?.data?.total}건 조회됨`, 'info');
          // console.log( "getList()---------------> rows:\n", r );
          this.totalRows = r.result.data.total;
          this.page = r.result.data.page;
          this.rows = r.result.data.rows;

          //this.rows = r.result.rs;
          //this.totalRows = r.result.rs.length;
          //await this.toastInfo(`경보 정보 ${this.rows.length}건 조회됨`, 'info');
          if( this.isShowGraph ) this.makeGraphData(r.result.stat)
        }

      }catch(err){
        await this.alertDanger(err.message);
        console.log( err );
      }
    },

    makeGraphData(rs){
      let labelsMap = {};
      let dataMap = {};
      rs.map(r=>{
        labelsMap[r.tid] = [];
        dataMap[r.tid] = { tid: r.tid, datasets: { backgroundColor:[], data: [] } };
      })

      rs.map(r=>{
       labelsMap[r.tid].push( this.eventCodeMap[r.code] )
       dataMap[r.tid].datasets.data.push( r.count );
       dataMap[r.tid].datasets.backgroundColor.push( _eventBgColor[r.code] );
      })

      this.dataMap = dataMap;
      this.labelsMap = labelsMap;
      this.isShowGraph = false;

    },

    rowSelected(){
      return true;
    },

    async exportExcel(){
      try{
        this.fileName = `event-log_${this.fromDts}_${this.toDts}.xls`;

        console.log( '------before-generate startDownload-----------', this.fileName);
        if( !this.downloadReason || this.downloadReason.length < 5 ){
          return await toastSync(this.$bvToast, "[사유 없음] 다운로드 사유는 5자 이상 입력해야 합니다.", 'danger');
        }
        const {currentRoute} = this.$router;
        const rs = await accessLogging(
          'download',
          currentRoute,
          '',
          this.downloadReason,
          `레코드수: ${this.rows.length}, 파일명: ${this.fileName}`
        );

        this.downloadReason = '';
        if(rs===true){
          return true;
        }else{
          await toastSync(this.$bvToast, "Error: "+rs.message, 'danger');
          return false;
        }

      }catch(err){
        console.log(err);
        return false;
      }
    },

    finishDownload(){
      this.$refs['download-modal'].hide();
    },



  }, // end of methods
  watch:{
    '$route.query': {
      handler: function(query) {
        // console.log('watch params--->', query);
        this.evtCode = query.code;
        this.fromDays = query.from;
      },
      deep: true,
      immediate: true
    },/*
    code(newVal, oldVal){
      console.log('[props] "code" changed: ', newVal, ' | was: ', oldVal);
    },
    from(newVal, oldVal){
      console.log('[props] "from" changed: ', newVal, ' | was: ', oldVal);
    },
    tankId(newVal, oldVal){
      console.log('[props] "tankId" changed: ', newVal, ' | was: ', oldVal);
    }*/
  }
}
</script>
